import { TabProps } from '../../../../nbr-filter/sections/content-tabs/tabs/types';
import { MetricsOptions } from '../../../../types';
import { FindARepTabStyles } from './tabs.style';
import { useTrackLDMetric } from '@exploration/feature-management';
import {
  AdvisorSearchInput,
  ChevronRight,
} from '@exploration/shared-components';

// --------------------------------------------------------------------------

const {
  TabsContent,
  TitleText,
  ContentText,
  PhoneLink,
  HoursText,
  VirtualAdvisorButton,
} = FindARepTabStyles;

// --------------------------------------------------------------------------

const FindARepTab = ({
  id,
  className,
  financialAdvisorId,
  VatId,
  VatLink,
  VatText,
}: TabProps) => {
  const { trackMetric } = useTrackLDMetric();
  const FAPageLink = 'https://local.thrivent.com/';
  return (
    <TabsContent className={className} value={id}>
      <TitleText as="h2">Ready to talk? We&#39;re here to listen.</TitleText>
      <ContentText as={'p'}>
        Schedule your free intro appointment with a financial advisor who can
        answer your questions.
      </ContentText>
      <AdvisorSearchInput
        link={{ href: FAPageLink, text: 'Search' }}
        analyticsId={financialAdvisorId}
      />
      {!!VatLink && (
        <div>
          <ContentText as={'p'}>
            Talk to a financial advisor, online or over the phone, when and how
            it’s convenient for you.
          </ContentText>
          <VirtualAdvisorButton
            href={VatLink}
            target="_blank"
            variant="secondary"
            id={VatId}
            onClick={() => trackMetric(MetricsOptions.nbrAdvisorConnectClick)}
            weight="subtle"
          >
            {VatText}
            <ChevronRight $hideOnMobile={true} />
          </VirtualAdvisorButton>
        </div>
      )}
      <TitleText as="h2">Client Care Center</TitleText>
      <ContentText as={'p'}>
        For general questions, call:{' '}
        <PhoneLink href="tel:8008474836">800-847-4836</PhoneLink>
      </ContentText>
      <HoursText as={'p'}>Monday-Friday 7 a.m. to 6 p.m. CT</HoursText>
    </TabsContent>
  );
};

// --------------------------------------------------------------------------

export default FindARepTab;
